import { WizardStep } from "./WizardStep";
import { IAutoWizardModel } from "../interfaces/IAutoWizardModel";
import { QuoteFormEventType } from "../../../Common/QuoteFormEventTracking/QuoteFormEventType";
import { handleQuoteFormEvent } from "../../../Common/QuoteFormEventTracking/Utils";

const SERVER_SIDE_ERROR_CLASS = "input-validation-error";

declare const awl: any;
declare const awlDataLayer: any;

export const sectionClasses = "layout-section form-section";

export function initFormSubmit(): void {
    const quoteForm = document.getElementById("quoteform") as HTMLFormElement;
    const submitButton = document.getElementById("FormSubmit") as HTMLButtonElement;

    submitButton.addEventListener("click", function() {
        quoteForm.submit();
    });

}

export function elementHasClass(element: HTMLElement, className: string): boolean {
    if (element.classList)
        return element.classList.contains(className);
    else
        return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
}

export function contactInfoNameStepHasServerSideErrors(firstNameInputElementId: string, lastNameInputElementId: string, emailInputElementId: string): boolean {

    const firstNameInputElement = document.getElementById(firstNameInputElementId) as HTMLInputElement;
    const lastNameInputElement = document.getElementById(lastNameInputElementId) as HTMLInputElement;
    const emailInputElement = document.getElementById(emailInputElementId) as HTMLInputElement;

    return elementHasClass(firstNameInputElement, SERVER_SIDE_ERROR_CLASS) ||
        elementHasClass(lastNameInputElement, SERVER_SIDE_ERROR_CLASS) ||
        elementHasClass(emailInputElement, SERVER_SIDE_ERROR_CLASS);
}
    
export function contactInfoAddressStepHasServerSideErrors(addressInputElementId: string, zipCodeInputElementId: string, phoneInputElementId: string): boolean {

    const addressInputElement = document.getElementById(addressInputElementId) as HTMLInputElement;
    const zipCodeInputElement = document.getElementById(zipCodeInputElementId) as HTMLInputElement;
    const phoneInputElement = document.getElementById(phoneInputElementId) as HTMLInputElement;

    return elementHasClass(addressInputElement, SERVER_SIDE_ERROR_CLASS) ||
        elementHasClass(zipCodeInputElement, SERVER_SIDE_ERROR_CLASS) ||
        elementHasClass(phoneInputElement, SERVER_SIDE_ERROR_CLASS);
}

export function contactInfoAddressHasServerSideErrors(addressInputElementId: string): boolean {

    const addressInputElement = document.getElementById(addressInputElementId) as HTMLInputElement;

    return elementHasClass(addressInputElement, SERVER_SIDE_ERROR_CLASS);
}

export function contactInfoZipCodeHasServerSideErrors(zipCodeInputElementId: string): boolean {

    const zipCodeInputElement = document.getElementById(zipCodeInputElementId) as HTMLInputElement;

    return elementHasClass(zipCodeInputElement, SERVER_SIDE_ERROR_CLASS);
}

export function contactInfoPhoneHasServerSideErrors(phoneInputElementId: string): boolean {
    
    const phoneInputElement = document.getElementById(phoneInputElementId) as HTMLInputElement;

    return elementHasClass(phoneInputElement, SERVER_SIDE_ERROR_CLASS);
}

export function showCtaAndLegalSections(): void {
    const ctaSection: HTMLDivElement = document.querySelector("#CtaSection .cta") as HTMLDivElement;
    const legalSection: HTMLDivElement = document.getElementById("legal-content") as HTMLDivElement;

    ctaSection.style.display = "block";
    legalSection.style.display = "block";
}
    
export function hideCtaAndLegalSections(): void {
    const ctaSection: HTMLDivElement = document.querySelector("#CtaSection .cta") as HTMLDivElement;
    const legalSection: HTMLDivElement = document.getElementById("legal-content") as HTMLDivElement;

    ctaSection.style.display = "none";
    legalSection.style.display = "none";
}

export function toggleFotocUninsuredDisplay(showForUninsuredOnly: boolean): void {
    if (showForUninsuredOnly) {
        const forInsuredBrands = document.getElementsByClassName("for-insured");

        for (let i = 0; i < forInsuredBrands.length; i++) {
           const brandElement = forInsuredBrands.item(i) as HTMLDivElement;
           brandElement.style.display = "none";
        }

        const forUninsuredBrands = document.getElementsByClassName("for-uninsured");

        for (let i = 0; i < forUninsuredBrands.length; i++) {
           const brandElement = forUninsuredBrands.item(i) as HTMLDivElement;
           brandElement.style.display = "inline-block";
        }

        return;
    }

    const forUninsuredBrands = document.getElementsByClassName("for-uninsured");

    for (let i = 0; i < forUninsuredBrands.length; i++) {
        const brandElement = forUninsuredBrands.item(i) as HTMLDivElement;
        brandElement.style.display = "none";
    }
    
    const forInsuredBrands = document.getElementsByClassName("for-insured");

    for (let i = 0; i < forInsuredBrands.length; i++) {
        const brandElement = forInsuredBrands.item(i) as HTMLDivElement;
        brandElement.style.display = "inline-block";
    }
}

export function redirectToRoutePath(routePath: string): void {
    // This is a hack and not idiomatic from the point of view
    // of react-router. However, due to time constraints we
    // were not able to figure out how to make the redirects
    //
    //  return <Redirect to={ this.state.redirectPath } />;
    //
    // push to history. This hack solves the problem.
    window.location.hash = '#' + routePath;
}

export function getRoutePath(step: WizardStep) {
    switch (step) {
        case WizardStep.PRIMARY_VEHICLE_YEAR:
            return "/";
        case WizardStep.PRIMARY_VEHICLE_MAKE:
            return "/VehicleMake";
        case WizardStep.PRIMARY_VEHICLE_MODEL:
            return "/VehicleModel";
        case WizardStep.ADD_SECOND_VEHICLE:
            return "/AddVehicle";
        case WizardStep.SECONDARY_VEHICLE_YEAR:
            return "/AdditionalVehicleYear";
        case WizardStep.SECONDARY_VEHICLE_MAKE:
            return "/AdditionalVehicleMake";
        case WizardStep.SECONDARY_VEHICLE_MODEL:
            return "/AdditionalVehicleModel";
        case WizardStep.INSURANCE_CARRIER:
            return "/InsuranceCarrier";
        case WizardStep.INSURED_SINCE:
            return "/InsuredSince";
        case WizardStep.GENDER:
            return "/Gender";
        case WizardStep.CREDIT_HISTORY:
            return "/CreditRating";
        case WizardStep.LICENSE_STATUS:
            return "/LicenseStatus";
        case WizardStep.FILING_REQUIRED:
            return "/FilingRequired";
        case WizardStep.INCIDENTS:
            return "/Incidents";
        case WizardStep.MARITAL_STATUS:
            return "/MaritalStatus";
        case WizardStep.IS_MILITARY:
            return "/IsMilitary";
        case WizardStep.HOMEOWNER:
            return "/Homeowner";
        case WizardStep.HOME_ADDON_BUNDLE:
            return "/Bundle";
        case WizardStep.HOME_ADDON_YEAR_BUILT:
            return "/YearBuilt";
        case WizardStep.HOME_ADDON_PROPERTY_TYPE:
            return "/PropertyType";
        case WizardStep.HOME_ADDON_ANY_CLAIMS:
            return "/AnyClaims";
        case WizardStep.HOME_ADDON_INTERESTED_IN_FLOOD_INSURANCE:
            return "/FloodInsurance";
        case WizardStep.PET_INSURANCE:
            return "/PetInsurance";
        case WizardStep.BIRTH_YEAR:
            return "/BirthYear";
        case WizardStep.BIRTH_MONTH:
            return "/BirthMonth";
        case WizardStep.BIRTH_DAY:
            return "/BirthDay";
        case WizardStep.AGE:
            return "/Age";
        case WizardStep.CONTACT_INFO_NAME:
            return "/ContactInfoName";
        case WizardStep.CONTACT_INFO_ADDRESS:
            return "/ContactInfoAddress";
        case WizardStep.PRE_FILLED_QUOTE:
            return "/PreFilledQuote";
        case WizardStep.ADDITIONAL_DRIVER:
            return "/AdditionalDriver";
        case WizardStep.ADDITIONAL_DRIVER_BIRTH_YEAR:
            return "/AdditionalDriverBirthYear";
        case WizardStep.ADDITIONAL_DRIVER_BIRTH_MONTH:
            return "/AdditionalDriverBirthMonth";
        case WizardStep.ADDITIONAL_DRIVER_BIRTH_DAY:
            return "/AdditionalDriverBirthDay";
        case WizardStep.ADDITIONAL_DRIVER_NAME:
            return "/AdditionalDriverName";
    }
}

// Convert JS boolean to ASP.NET True/False form value
export function toAspNetTrueFalse(value: boolean): string {
    return value ? "True" : "False";
}

export function mapFormValuesToModel(): IAutoWizardModel {

    const birthDate: string[] = (document.getElementById("PrimaryDriver_BirthDate") as HTMLInputElement).value.split("/");
    let birthYear = "";

    if (birthDate.length === 3 && typeof birthDate[0] !== 'undefined') {
        birthYear = birthDate[2].split(" ")[0];
    }

    const additionalDriverBirthDate: string[] = (document.getElementById("AdditionalDriver_BirthDate") as HTMLInputElement).value.split("/");
    let additionalDriverBirthYear = "";

    if (additionalDriverBirthDate.length === 3 && typeof additionalDriverBirthDate[0] !== 'undefined') {
        additionalDriverBirthYear = additionalDriverBirthDate[2].split(" ")[0];
    }

    let interestedInPetInsurance = "False";

    if (document.getElementById("InterestedInPetInsurance") as HTMLInputElement) {
        interestedInPetInsurance = (document.getElementById("InterestedInPetInsurance") as HTMLInputElement).value
    }

    toggleFotocUninsuredDisplay((document.getElementById("Insurance_CurrentInsurance_CurrentlyInsured") as HTMLInputElement).value == "False");    

    return {
        primaryVehicle: {
            id: (document.getElementById("PrimaryVehicle_Id") as HTMLInputElement).value,
            year: (document.getElementById("PrimaryVehicle_Year") as HTMLInputElement).value,
            make: (document.getElementById("PrimaryVehicle_Make") as HTMLInputElement).value,
            model: (document.getElementById("PrimaryVehicle_Model") as HTMLInputElement).value
        },

        numAdditionalVehicles: (document.getElementById("NumAdditionalVehicles") as HTMLInputElement).value,

        additionalVehicles: [
            {
                id: (document.getElementById("AdditionalVehicles_0__Id") as HTMLInputElement).value,
                year: (document.getElementById("AdditionalVehicles_0__Year") as HTMLInputElement).value,
                make: (document.getElementById("AdditionalVehicles_0__Make") as HTMLInputElement).value,
                model: (document.getElementById("AdditionalVehicles_0__Model") as HTMLInputElement).value
            }
        ],
        
        primaryDriver: {
            id: (document.getElementById("PrimaryDriver_Id") as HTMLInputElement).value,
            vehicleId: (document.getElementById("PrimaryDriver_VehicleId") as HTMLInputElement).value,
            relation: (document.getElementById("PrimaryDriver_Relation") as HTMLInputElement).value,
            licenseStatus: (document.getElementById("PrimaryDriver_LicenseStatus") as HTMLInputElement).value,
            filingRequired: (document.getElementById("PrimaryDriver_FilingRequired") as HTMLInputElement).value,
            gender: (document.getElementById("PrimaryDriver_Gender") as HTMLInputElement).value,
            married: (document.getElementById("PrimaryDriver_Married") as HTMLInputElement).value,
            birthMonth: birthDate[0],
            birthDay: birthDate[1],
            birthYear: birthYear,
        },

        hasAdditionalDriver: (document.getElementById("HasAdditionalDriver") as HTMLInputElement).value,

        additionalDriver: {
            firstName: (document.getElementById("AdditionalDriver_FirstName") as HTMLInputElement).value,
            lastName: (document.getElementById("AdditionalDriver_LastName") as HTMLInputElement).value,
            birthMonth: additionalDriverBirthDate[0],
            birthDay: additionalDriverBirthDate[1],
            birthYear: additionalDriverBirthYear,
        },

        applicantInfo: {
            currentResidence: (document.getElementById("ApplicantInfo_CurrentResidence") as HTMLInputElement).value,
            creditRating: (document.getElementById("ApplicantInfo_CreditRating") as HTMLInputElement).value,
            isMilitary: (document.getElementById("ApplicantInfo_IsMilitary") as HTMLInputElement).value
        },

        currentInsurance: {
            currentlyInsured: (document.getElementById("Insurance_CurrentInsurance_CurrentlyInsured") as HTMLInputElement).value,
            insuredSince: (document.getElementById("Insurance_CurrentInsurance_InsuredSince") as HTMLInputElement).value,
            insuranceCarrier: (document.getElementById("Insurance_CurrentInsurance_InsuranceCarrier") as HTMLInputElement).value
        },

        homeAddon: {
            bundle: (document.getElementById("HomeAddon_Bundle") as HTMLInputElement).value,
            propertyType: (document.getElementById("HomeAddon_PropertyType") as HTMLInputElement).value,
            anyClaims: (document.getElementById("HomeAddon_AnyClaims") as HTMLInputElement).value,
            interestedInFloodInsurance: (document.getElementById("HomeAddon_InterestedInFloodInsurance") as HTMLInputElement).value,
            yearBuilt: (document.getElementById("HomeAddon_YearBuilt") as HTMLInputElement).value,
            homeMortgageRefinanceQuoteInterest: (document.getElementById("HomeAddon_HomeMortgageRefinanceQuoteInterest") as HTMLInputElement).value,
        },

        atFaultAccidentInThePastThreeYears: (document.getElementById("AtFaultAccidentInThePastThreeYears") as HTMLInputElement).value,
        twoOrMoreTicketsInThePastThreeYears: (document.getElementById("TwoOrMoreTicketsInThePastThreeYears") as HTMLInputElement).value,
        duiConvictionInThePastThreeYears: (document.getElementById("DuiConvictionInThePastThreeYears") as HTMLInputElement).value,
        interestedInPetInsurance: interestedInPetInsurance,
        resumeActionName: "",

        contactInfo: {
            firstName: (document.getElementById("ContactInfo_FirstName") as HTMLInputElement).value,
            lastName: (document.getElementById("ContactInfo_LastName") as HTMLInputElement).value,
            email: (document.getElementById("ContactInfo_Email") as HTMLInputElement).value,
            address: (document.getElementById("ContactInfo_Address") as HTMLInputElement).value,
            address2: (document.getElementById("ContactInfo_Address2") as HTMLInputElement).value,
            addressStatus: (document.getElementById("ContactInfo_AddressStatus") as HTMLInputElement).value,
            zipCode: (document.getElementById("ContactInfo_ZipCode") as HTMLInputElement).value,
            phoneDay: (document.getElementById("ContactInfo_PhoneDay") as HTMLInputElement).value
        }
    };
}

export function mapModelToFormValues(model: IAutoWizardModel): void {

    // Primary Vehicle
    (document.getElementById("PrimaryVehicle_Id") as HTMLInputElement).value = model.primaryVehicle.id;
    (document.getElementById("PrimaryVehicle_Year") as HTMLInputElement).value = model.primaryVehicle.year;
    (document.getElementById("PrimaryVehicle_Make") as HTMLInputElement).value = model.primaryVehicle.make;
    (document.getElementById("PrimaryVehicle_Model") as HTMLInputElement).value = model.primaryVehicle.model;

    // Additional Vehicles
    (document.getElementById("NumAdditionalVehicles") as HTMLInputElement).value = model.numAdditionalVehicles;

    (document.getElementById("AdditionalVehicles_0__Id") as HTMLInputElement).value = model.additionalVehicles[0].id;
    (document.getElementById("AdditionalVehicles_0__Year") as HTMLInputElement).value = model.additionalVehicles[0].year;
    (document.getElementById("AdditionalVehicles_0__Make") as HTMLInputElement).value = model.additionalVehicles[0].make;
    (document.getElementById("AdditionalVehicles_0__Model") as HTMLInputElement).value = model.additionalVehicles[0].model;

    // Primary Driver
    (document.getElementById("PrimaryDriver_Id") as HTMLInputElement).value = model.primaryDriver.id;
    (document.getElementById("PrimaryDriver_VehicleId") as HTMLInputElement).value = model.primaryDriver.vehicleId;
    (document.getElementById("PrimaryDriver_Relation") as HTMLInputElement).value = model.primaryDriver.relation;
    (document.getElementById("PrimaryDriver_LicenseStatus") as HTMLInputElement).value = model.primaryDriver.licenseStatus;
    (document.getElementById("PrimaryDriver_FilingRequired") as HTMLInputElement).value = model.primaryDriver.filingRequired;
    (document.getElementById("PrimaryDriver_Gender") as HTMLInputElement).value = model.primaryDriver.gender;
    (document.getElementById("PrimaryDriver_Married") as HTMLInputElement).value = model.primaryDriver.married;
    (document.getElementById("PrimaryDriver_BirthDate") as HTMLInputElement).value = model.primaryDriver.birthMonth + '/' + model.primaryDriver.birthDay + '/' + model.primaryDriver.birthYear;
    
    // Applicant Info
    (document.getElementById("ApplicantInfo_CurrentResidence") as HTMLInputElement).value = model.applicantInfo.currentResidence;
    (document.getElementById("ApplicantInfo_CreditRating") as HTMLInputElement).value = model.applicantInfo.creditRating;
    (document.getElementById("ApplicantInfo_IsMilitary") as HTMLInputElement).value = model.applicantInfo.isMilitary;


    // Current Insurance
    (document.getElementById("Insurance_CurrentInsurance_CurrentlyInsured") as HTMLInputElement).value = model.currentInsurance.currentlyInsured;
    (document.getElementById("Insurance_CurrentInsurance_InsuredSince") as HTMLInputElement).value = model.currentInsurance.insuredSince;
    (document.getElementById("Insurance_CurrentInsurance_InsuranceCarrier") as HTMLInputElement).value = model.currentInsurance.insuranceCarrier;

    toggleFotocUninsuredDisplay(model.currentInsurance.currentlyInsured == "False");
 
    // Home Add-on
    (document.getElementById("HomeAddon_Bundle") as HTMLInputElement).value = model.homeAddon.bundle;
    (document.getElementById("HomeAddon_PropertyType") as HTMLInputElement).value = model.homeAddon.propertyType;
    (document.getElementById("HomeAddon_AnyClaims") as HTMLInputElement).value = model.homeAddon.anyClaims;
    (document.getElementById("HomeAddon_InterestedInFloodInsurance") as HTMLInputElement).value = model.homeAddon.interestedInFloodInsurance;
    (document.getElementById("HomeAddon_YearBuilt") as HTMLInputElement).value = model.homeAddon.yearBuilt;
    (document.getElementById("HomeAddon_HomeMortgageRefinanceQuoteInterest") as HTMLInputElement).value = model.homeAddon.homeMortgageRefinanceQuoteInterest;

    // Incidents
    (document.getElementById("AtFaultAccidentInThePastThreeYears") as HTMLInputElement).value = model.atFaultAccidentInThePastThreeYears;
    (document.getElementById("TwoOrMoreTicketsInThePastThreeYears") as HTMLInputElement).value = model.twoOrMoreTicketsInThePastThreeYears;
    (document.getElementById("DuiConvictionInThePastThreeYears") as HTMLInputElement).value = model.duiConvictionInThePastThreeYears;

    // Pet Insurance
    if (document.getElementById("InterestedInPetInsurance") as HTMLInputElement) {
        (document.getElementById("InterestedInPetInsurance") as HTMLInputElement).value = model.interestedInPetInsurance;
    }

    // Contact Info
    (document.getElementById("ContactInfo_FirstName") as HTMLInputElement).value = model.contactInfo.firstName;
    (document.getElementById("ContactInfo_LastName") as HTMLInputElement).value = model.contactInfo.lastName;
    (document.getElementById("ContactInfo_Email") as HTMLInputElement).value = model.contactInfo.email;
    (document.getElementById("ContactInfo_Address") as HTMLInputElement).value = model.contactInfo.address;
    (document.getElementById("ContactInfo_Address2") as HTMLInputElement).value = model.contactInfo.address2;
    (document.getElementById("ContactInfo_AddressStatus") as HTMLInputElement).value = model.contactInfo.addressStatus;
    (document.getElementById("ContactInfo_ZipCode") as HTMLInputElement).value = model.contactInfo.zipCode;
    (document.getElementById("ContactInfo_PhoneDay") as HTMLInputElement).value = model.contactInfo.phoneDay;

    //Additional Driver
    (document.getElementById("HasAdditionalDriver") as HTMLInputElement).value = model.hasAdditionalDriver;
    (document.getElementById("AdditionalDriver_FirstName") as HTMLInputElement).value = model.additionalDriver.firstName;
    (document.getElementById("AdditionalDriver_LastName") as HTMLInputElement).value = model.additionalDriver.lastName;
    (document.getElementById("AdditionalDriver_BirthDate") as HTMLInputElement).value = model.additionalDriver.birthMonth + '/' + model.additionalDriver.birthDay + '/' + model.additionalDriver.birthYear;
}

export function updateDataLayerVehicleVariable(year: string, make: string, model: string): void {
    const vehicle = `${year} ${make} ${model}`;

    if (typeof awlDataLayer !== 'undefined') {
        awlDataLayer.push({ 'autoLeadVehicleInformation': vehicle });
    }
}

export function updateDataLayerFirstName(firstName: string): void {
    if (typeof awlDataLayer !== 'undefined') {
        awlDataLayer.push({ 'autoLeadDriverFirstName': firstName });
    }
}

export function isIEOrEdgeBrowser() {

    const ua = window.navigator.userAgent;
    const msie = ua.indexOf("MSIE ");

    if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./) || !!navigator.userAgent.match(/Edge\/\d+/)) {
        return true;
    }

    return false;
}

export function isIEOrEdgeDesktopBrowser() {
    if (window.innerWidth > 768 && isIEOrEdgeBrowser()) {
        return true;
    }

    return false;
}

export function isMobile() {
    let isMobile = false; //initiate as false
    // device detection
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
        isMobile = true;
    return isMobile;
}

function logUserLeftQuoteFormEvent() {
    handleQuoteFormEvent(QuoteFormEventType.UserLeftForm, "User Left Quote Form", "AutoWizard");
    awl.logger.info(awl.autoWizard.loggerName, "AutoWizard - Consumer is leaving form on [step: " + QuoteFormEventType.UserLeftForm + "]");
}

export function initCaptureQuoteFormUnload() {
    if (isMobile()) {
        window.addEventListener("pagehide", logUserLeftQuoteFormEvent);
    } else {
        window.addEventListener("beforeunload", logUserLeftQuoteFormEvent);
    }
}

export function cleanUpCaptureQuoteFormUnload() {
    if (isMobile()) {
        window.removeEventListener("pagehide", logUserLeftQuoteFormEvent);
    } else {
        window.removeEventListener("beforeunload", logUserLeftQuoteFormEvent);
    }
}



export function saveResumeDataInLocalStorage(model: IAutoWizardModel, resumeActionName: string) {
    if (awl.autoWizard.supportsSessionResume) {
        model.resumeActionName = resumeActionName.substring(1);
        localStorage.setItem('resumeDataAutoWizard', JSON.stringify(model));
        document.cookie = awl.autoWizard.consumerDataCookie;
    }
}

export const formatPhoneNumber = (value: string) => {
    // return nothing if no value
    if (!value) return value;

    // only allows 0-9 inputs
    const currentValue = value.replace(/[^\d]/g, '');
    const cvLength = currentValue.length;

    // returns: "x", "xx", "xxx"
    if (cvLength < 4) return currentValue;

    // returns: "(xxx)", "(xxx) x", "(xxx) xx", "(xxx) xxx",
    if (cvLength < 7) return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`;

    // returns: "(xxx) xxx-", (xxx) xxx-x", "(xxx) xxx-xx", "(xxx) xxx-xxx", "(xxx) xxx-xxxx"
    return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3, 6)}-${currentValue.slice(6, 10)}`;
}

export const formatPhoneNumberForStateUpdate = (value: string, previousValue: string) => {
    // return nothing if no value
    if (!value) return value;

    if (!previousValue || value.length > previousValue.length) {

        return formatPhoneNumber(value);
    }

    return value;
}

export const cleanUpNumericValue = (value: string) => {
    // return nothing if no value
    if (!value) return value;

    return value.replace(/[^\d]/g, '');
}